module.exports = __webpack_public_path__ + "app/img/logo-messenger.b04d6a16.svg";